import seqStore from '../../store/seqStore'

export default function Octave() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const octave = seqStore((state) => state.settings.octave)
    const setOctave = seqStore((state) => state.setOctave)

    // OCTAVE CONTROLS
    const handleOctave = (e) => {
        const value = e.target.value
        setOctave(currentTrack, value)
    }

    const resetOctave = () => {
        setOctave(currentTrack, 0)
    }
    
    return (
        <div id='octaveInput'>
            <label htmlFor="root note"  ><p>Octave <span>{octave[currentTrack]}</span></p></label>
            <input id='enabledInput' type="range" min={-3} max={3} step='1' value={octave[currentTrack]} onChange={e => handleOctave(e)} onDoubleClick={resetOctave} />
        </div>
    )
}
